import React from "react";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { Divider, Typography } from "@material-ui/core";
import { Button } from "../../components/ui/button";
import { StorageLimitAccess } from "../../components/DialogComponent/SupplyDataDialog";
import { FileSpreadsheetIcon, FileText } from "lucide-react";

export function SuccessEmailDialog({
  openDialog,
  handleCloseDialog,
  to,
  attachExcel,
  fileName,
  reportDate,
  attachPdf,
  pdfFileName,
  attachFullPdf,
  fullPdfName,
  attachFullExcel,
}) {
  return (
    <Dialog
      open={openDialog}
      onOpenChange={handleCloseDialog}
      maxWidth="sm"
      fullWidth
    >
      <Typography variant="body" className="mt-20 dialogTitle">
        Email Sent Successfully
      </Typography>
      <Divider className="mt-10" />
      <DialogContent className="pv-5">
        <div>
          <div>
            <div className="text-center font-bold text-lg dark:text-white mb-15">Thank You.</div>
            <div className="text-base dark:text-white mb-15 leading-relaxed">
              Your email has been sent to{" "}
              <span className="text-gray-500 dark:text-white">{to}</span>
            </div>
          </div>
          <div className="mv-10">
            <div className="mb-10 mt-10 dark:text-white">Attach Files:</div>
            {attachExcel === true && (
              <div className="flex items-center gap-2 text-gray-700 dark:text-white mb-4">
                <FileText color="#27ae60" size={18} />
                <span>
                  {fileName}.xlsx_{reportDate}
                </span>
              </div>
            )}
            {attachPdf === true && (
              <div>
                <div className="flex items-center gap-2 text-gray-700 dark:text-white mb-4">
                  <FileSpreadsheetIcon color="#e74c3c" size={18} />
                  <span>
                    {pdfFileName}_{reportDate}
                  </span>
                </div>
              </div>
            )}
            {attachFullPdf === true && (
              <div>
                <div className="flex items-center gap-2 text-gray-700 dark:text-white mb-4">
                  <FileSpreadsheetIcon color="#e74c3c" size={18} />
                  <span>
                    {fullPdfName}_{reportDate}
                  </span>
                </div>
              </div>
            )}
            {attachFullExcel === true && (
              <div>
                <div className="flex items-center gap-2 text-gray-700 dark:text-white mb-4">
                  <FileText color="#27ae60" size={18} />
                  <span>
                    {fileName}.xlsx_{reportDate}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex flex-justify-center">
          <Button
            onClick={handleCloseDialog}
            variant="contained"
            className="ph-30 mb-15"
            style={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "10px",
            }}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
export function ErrorDialog({openErrDialog, handleCloseErrDialog, to}) {
  return (
    <Dialog open={openErrDialog} onOpenChange={handleCloseErrDialog}>
      <DialogContent>
      <DialogTitle className="font-bold dark:text-gray-500">Email Sent Failed</DialogTitle>
        <div className="text-[#6B7280]">
          ! oops Your Email Cannot be sent to {to}
        </div>
      <div className="d-flex flex-justify-center mv-20">
        <Button onClick={handleCloseErrDialog} color="primary" style={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "10px",
            }}>
          Close
        </Button>
      </div>
      </DialogContent>
    </Dialog>
  );
}

export function StorageDialog({dialogOpen, handleDialogClose, auth}) {
  return (
    <StorageLimitAccess
      open={dialogOpen}
      onClose={handleDialogClose}
      auth={auth}
    />
  );
}
